export default "__VITE_ASSET__DPMjEJ7D__"